export const routes = (prefix=`pharmacy`) => [
    {
        path: `/${prefix}/ip-drug-dispensing`,
        name: `${prefix}.ip-drug-dispensing.index`,
        component: () => import('./Index.vue'),
        meta: {
            requiresAuth: true,
            permissions: {
                PageName: `${prefix}.ip-drug-dispensing.index`,
                PageDescription: "Pharmacy - IP Drug Dispensing",
            },
        },
    },
];
